import React, { useState } from "react";
import http from "../Utils/axiosConfig";
import { apiMessage } from "../Utils/apiMessage";
import ToastService from "../Utils/ToastService";
import "./ChangePassword.css";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setApiError("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.currentPassword)
      newErrors.currentPassword = "सध्याचा पासवर्ड आवश्यक आहे";
    if (!formData.newPassword)
      newErrors.newPassword = "नवीन पासवर्ड आवश्यक आहे";
    else if (formData.newPassword.length < 4)
      newErrors.newPassword = "नवीन पासवर्ड किमान 4 अक्षरांचा असावा";
    if (!formData.confirmNewPassword)
      newErrors.confirmNewPassword = "पासवर्डची पुष्टी करा";
    else if (formData.newPassword !== formData.confirmNewPassword)
      newErrors.confirmNewPassword = "नवीन पासवर्ड जुळत नाही";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const res = await http.post("login/change-password", {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });

      if (res.code === "PASSWORD_CHANGED") {
        ToastService.success("पासवर्ड यशस्वीरित्या बदलला ✅");
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        });
      } else if (res.code === "INCORRECT_PASSWORD") {
        setErrors((prev) => ({
          ...prev,
          currentPassword: "सध्याचा पासवर्ड चुकीचा आहे",
        }));
      } else {
        setApiError(apiMessage(res, "पासवर्ड बदलणे अयशस्वी"));
      }
    } catch (err) {
      console.error("Change password error:", err);
      setApiError(apiMessage());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-container">
      <form onSubmit={handleSubmit}>
        <div className="cp-form">
          <h2>पासवर्ड बदला</h2>

          <label className="label">सध्याचा पासवर्ड</label>
          <input
            type="password"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleChange}
          />
          {errors.currentPassword && (
            <p className="error error-input">{errors.currentPassword}</p>
          )}

          <label className="label">नवीन पासवर्ड</label>
          <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
          />
          {errors.newPassword && (
            <p className="error error-input">{errors.newPassword}</p>
          )}

          <label className="label">नवीन पासवर्डची पुष्टी करा</label>
          <input
            type="password"
            name="confirmNewPassword"
            value={formData.confirmNewPassword}
            onChange={handleChange}
          />
          {errors.confirmNewPassword && (
            <p className="error error-input">{errors.confirmNewPassword}</p>
          )}

          {apiError && <p className="error api-error">{apiError}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "जतन होत आहे..." : "पासवर्ड बदला"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
